import { render, staticRenderFns } from "./module-management.vue?vue&type=template&id=0a90315e&scoped=true"
import script from "./module-management.vue?vue&type=script&lang=js"
export * from "./module-management.vue?vue&type=script&lang=js"
import style0 from "./module-management.vue?vue&type=style&index=0&id=0a90315e&prod&lang=scss&scoped=true"
import style1 from "./module-management.vue?vue&type=style&index=1&id=0a90315e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90315e",
  null
  
)

export default component.exports